import styled from '@emotion/styled';

export const DivDialogBody = styled.div`
    display: block;
    font-size: 13px;
    white-space: pre-line;
    padding-top: 1rem;
`;

export const DivHeadline = styled.div`
    display: block;
    font-size: 17px;
    white-space: pre-line;
`;

export const DivTitle = styled.div`
    display: block;
    font-size: 15px;
    white-space: pre-line;
    font-weight: bold;
`;

export const DialogEditActionsWrapper = styled.div`
    display: inline-grid;
    grid-template-columns: 2fr auto;
    justify-content: end;
    column-gap: 0.5rem;
    width: 100%;
`;
